/**
 * Bannière de succès pour les générateurs PDF — design Carbon
 */

import { Tile, Layer, Button } from '@carbon/react'
import { Download, CheckmarkFilled, Renew } from '@carbon/icons-react'
import styles from './AiSuccessBanner.module.scss'

export interface AiSuccessBannerProps {
  title: string
  fileName: string
  onDownload: () => void
  onNewGeneration: () => void
  className?: string
}

export function AiSuccessBanner({
  title,
  fileName,
  onDownload,
  onNewGeneration,
  className = '',
}: AiSuccessBannerProps) {
  return (
    <Layer className={`${styles.wrapper} ${className}`}>
      <Tile className={styles.tile}>
        <div className={styles.content}>
          <div className={styles.iconWrapper}>
            <CheckmarkFilled size={24} className={styles.icon} />
          </div>
          <div className={styles.textBlock}>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.subtitle}>
              Le fichier &quot;{fileName}&quot; a été téléchargé.
            </p>
          </div>
          <div className={styles.actions}>
            <Button
              kind="tertiary"
              size="sm"
              renderIcon={Download}
              onClick={onDownload}
            >
              Télécharger à nouveau
            </Button>
            <Button
              kind="primary"
              size="sm"
              renderIcon={Renew}
              onClick={onNewGeneration}
            >
              Nouvelle génération
            </Button>
          </div>
        </div>
      </Tile>
    </Layer>
  )
}
